const useAdTargeting = () => {
  const btUser = getBtUser()

  return {
    page: "homePage",
    pageId: "homePage",
    is_home: "yes",
    pmatic: "no",
    ...(btUser && { btUser }),
  }
}

const getBtUser = () => {
  const userAgent = typeof window === "undefined" ? null : navigator.userAgent?.toLowerCase() || ""

  const bots = [
    "ahrefsbot",
    "bingbot",
    "duckduckbot",
    "facebot",
    "googlebot",
    "google web preview",
    "google-read-aloud",
    "moatbot",
    "pinterestbot",
    "ruxitsynthetic",
    "semrushbot",
    "slurp",
    "yisouspider",
  ]

  // loop through potential bots to see if it matches the user agent
  return userAgent ? bots.some((bot) => userAgent.includes(bot)) : null
}

export default useAdTargeting
